import { createFileRoute } from '@tanstack/react-router';

import { fundDetailScreen, fundDetailSearch } from '@/modules/fund/route';
import { lazyScreen } from '@/shared/screen/lazy-screen';

// `/cadastro/fundos/:fundId` do legado (`router.tsx:1877`); `novo` é o cadastro. A aba vai em `?tab=` (U42).
export const Route = createFileRoute('/_app/cadastro/fundos/$fundId/')({
  validateSearch: fundDetailSearch,
  staticData: { screen: fundDetailScreen },
  component: lazyScreen(() => import('@/modules/fund/public').then((module) => ({ default: module.FundFormPage }))),
});
